// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__iPFHe","itemTitle":"ClientEmergencyInfo_itemTitle__2eaOj","itemText":"ClientEmergencyInfo_itemText__2CQ6F"};